import * as React from 'react';
import { Modal as UIKitModal } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import { jsx as _jsx } from "react/jsx-runtime";
var CLOSE_BUTTON_PROPS = {
  theme: 'fill_light',
  size: 'XS',
  icon: /*#__PURE__*/_jsx(IconActionClose12, {
    color: "current_color"
  }),
  title: 'Закрыть'
};
export function Modal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    children = _ref.children,
    header = _ref.header;
  return /*#__PURE__*/_jsx(UIKitModal, {
    open: open,
    onOpenChange: onClose,
    size: "M",
    closeButtonProps: CLOSE_BUTTON_PROPS,
    header: header,
    children: children
  });
}